import angular from 'angular'
import vehicleProducingAreaPage from './view/vehicleProducingArea.html'

class vehicleProducingAreaCtrl {
    constructor($scope, httpRequest, sweetalert) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                allStr: '',
            },
        }

        $scope.queryList = function queryList() {
            httpRequest.post_getVehicleOriginList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.importconfig = {
            code: 'VEHICLE_ORIGIN',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            callback() {
                $scope.queryList()
            },
        }
        $scope.upload = function upload() {
            const msg = '导入后将全面覆盖已有的产地列表，确定要导入吗？'
            sweetalert.confirm('确认上传', msg).then(() => {
                angular.element('#vehicleProducingArea_uploadFiles .j-importexcel').click()
            }, () => {})
        }
    }
}
vehicleProducingAreaCtrl.$inject = ['$scope', 'httpRequest', 'sweetalert']
export default angular.module('system.basedata.vehicleInfoTab.vehicleProducingArea', [])
    .controller('vehicleProducingAreaCtrl', vehicleProducingAreaCtrl)
    .component('vehicleProducingArea', {
        template: vehicleProducingAreaPage,
        controller: 'vehicleProducingAreaCtrl',
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/vehicleInfo/vehicleProducingAreaComponent.js